module.exports = new __parcel__URL__("warrior.07dfac48.png").toString();